export enum PunchoutReusableContent {
  EMPTY = 'N/A',
  DEFAULT_TOAST_ERROR = 'API Error'
}
